import React from 'react'
import FaqCategoryTable from '../../Components/FAQ-Components/FaqCategoryTable/FaqCategoryTable'

const FAQs = () => {
  return (
    <div className="HomePage" style={{ gap: '20px' }}>
        <FaqCategoryTable />
    </div>
  )
}

export default FAQs